import Service from './Service'

const getRegistrationMetadata = () => { return Service.defaultpost('/iam/registrationmetadata') }

const registration = (payload) => { return Service.defaultpost('/iam/registration', payload) }

const login = (payload) => { return Service.defaultpost('/iam/login', payload) }

const autologin = () => { return Service.get('/iam/autologin') }

const password_reset = (payload) => { return Service.post('/iam/passwordreset', payload) }

const forgot_password = (payload) => { return Service.defaultpost('/iam/forgotpassword', payload) }

const twoFactor = {
    generateSecret: (username) => { return Service.post('/iam/2fagenerate?username', { username: username }) },
    verify: (username, userToken) => { return Service.post('/iam/2faverify', { username: username, userToken: userToken }) },
}

const getUsers = (username) => { return Service.get('iam/getusers?username=' + username) }

const approverUser = (payload) => { return Service.post('/iam/approveuser', payload) }

const bulkApproverUser = (payload) => { return Service.post('/iam/bulkapproveuser', payload) }

const toggleLock = (username) => { return Service.get('iam/toggleLock?username=' + username) }

const editUser = (payload) => { return Service.post('/iam/edituser', payload) }

const addCompany = (customer) => { return Service.get('/iam/addCompany?customer=' + customer) }

const reset2FA = (payload) => { return Service.post('/iam/deactivatesfa', payload) }

const resetPassword = (payload) => { return Service.post('/iam/suforgotpassword', payload) }

// Public (unauthenticated) app config: read-only / migration flags + links.
const getAppConfig = () => { return Service.defaultget('/app/config') }

// Trigger self-migration of the logged-in user into the new ESP app.
const migrate = () => { return Service.post('/iam/migrate', {}) }

const IAMAService = {
    registration,
    login,
    autologin,
    password_reset,
    forgot_password,
    twoFactor,
    editUser,
    getUsers,
    approverUser,
    bulkApproverUser,
    toggleLock,
    getRegistrationMetadata,
    addCompany,
    reset2FA,
    resetPassword,
    getAppConfig,
    migrate,
}

export default IAMAService
